"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.extractGroupId = exports.default = void 0;
exports.getGroupedByLegSearchResult = getGroupedByLegSearchResult;
exports.getGroupedByLegSearchResults = getGroupedByLegSearchResults;
exports.getGroupedCheapestPriceByDate = getGroupedCheapestPriceByDate;
exports.groupByMinLength = groupByMinLength;
exports.initializeGroupState = initializeGroupState;
exports.isValidGroupPaths = isValidGroupPaths;
exports.itineraryGroupMap = itineraryGroupMap;
exports.legacyInitializeGroupState = legacyInitializeGroupState;
exports.markDisabledGroupItems = markDisabledGroupItems;
exports.updateGroupState = updateGroupState;
exports.updateItineraryGroup = updateItineraryGroup;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _every2 = _interopRequireDefault(require("lodash/every"));
var _find4 = _interopRequireDefault(require("lodash/find"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _join2 = _interopRequireDefault(require("lodash/join"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _memoize2 = _interopRequireDefault(require("lodash/memoize"));
var _values2 = _interopRequireDefault(require("lodash/values"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _reduce2 = _interopRequireDefault(require("lodash/reduce"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function extractGroupIdCacheResolver(itinerary, groupPaths) {
  return itinerary.id + groupPaths;
}
var extractGroupId = exports.extractGroupId = (0, _memoize2.default)(function (itinerary, groupPaths) {
  var groupValues = (0, _map2.default)(groupPaths, function (groupPath) {
    return (0, _get2.default)(itinerary, groupPath, '');
  });
  return (0, _join2.default)(groupValues, _constants.GROUP_VALUES_SEPARATOR);
}, extractGroupIdCacheResolver);
function isValidGroupPaths(groupPaths) {
  return (0, _isArray2.default)(groupPaths) && (0, _every2.default)(groupPaths, function (groupPath) {
    return typeof groupPath === 'string';
  });
}
function group(results, groupPaths, minGroupLength) {
  var groupedResults = (0, _values2.default)((0, _groupBy2.default)(results, function (result) {
    return extractGroupId(result, groupPaths);
  }));
  if (minGroupLength > _constants.MIN_GROUP_LENGTH) {
    return groupByMinLength(groupedResults, minGroupLength);
  }
  return groupedResults;
}
function itineraryGroupMap(groups) {
  var groupedIds = new Set();
  (0, _forEach2.default)(groups, function (group) {
    if (group.length > 1) {
      (0, _forEach2.default)(group, function (itinerary) {
        return groupedIds.add(itinerary.id);
      });
    }
  });
  return groupedIds;
}
function groupByMinLength(groups, minGroupLength) {
  var flattenedGroups = [];
  (0, _forEach2.default)(groups, function (itineraryGroup) {
    if (itineraryGroup.length < minGroupLength) {
      (0, _forEach2.default)(itineraryGroup, function (itinerary) {
        flattenedGroups.push([itinerary]);
      });
    } else {
      flattenedGroups.push(itineraryGroup);
    }
  });
  return flattenedGroups;
}
function initializeGroupState(group, itineraryLegHashMap) {
  var outboundItineraries = [];
  var inboundItineraries = [];
  var outboundIds = [];
  var outBounds = [];
  var inBounds = [];
  var inboundIds = [];
  var groupIds = (0, _map2.default)(group, 'id');
  (0, _each2.default)(group, function (result) {
    var _result$legs, _result$legs$, _result$legs2, _result$legs2$;
    var outboundId = result === null || result === void 0 ? void 0 : (_result$legs = result.legs) === null || _result$legs === void 0 ? void 0 : (_result$legs$ = _result$legs[0]) === null || _result$legs$ === void 0 ? void 0 : _result$legs$.id;
    var inboundId = result === null || result === void 0 ? void 0 : (_result$legs2 = result.legs) === null || _result$legs2 === void 0 ? void 0 : (_result$legs2$ = _result$legs2[1]) === null || _result$legs2$ === void 0 ? void 0 : _result$legs2$.id;
    if (!outboundIds.includes(outboundId)) {
      var _result$legs3;
      outboundIds.push(outboundId);
      outBounds.push(result === null || result === void 0 ? void 0 : (_result$legs3 = result.legs) === null || _result$legs3 === void 0 ? void 0 : _result$legs3[0]);
      outboundItineraries.push(result);
    }
    if (!inboundIds.includes(inboundId)) {
      var _result$legs4;
      inboundIds.push(inboundId);
      inBounds.push(result === null || result === void 0 ? void 0 : (_result$legs4 = result.legs) === null || _result$legs4 === void 0 ? void 0 : _result$legs4[1]);
      inboundItineraries.push(result);
    }
  });
  var outbound = (0, _map2.default)(outboundIds, function (id, i) {
    return {
      code: id,
      selected: i === 0,
      disabled: false,
      leg: outBounds[i],
      itinerary: outboundItineraries[i]
    };
  });
  var inbound = (0, _map2.default)(inboundIds, function (id, i) {
    return {
      code: id,
      selected: i === 0,
      disabled: false,
      leg: inBounds[i],
      itinerary: inboundItineraries[i]
    };
  });
  var selectedOutboundId = outboundIds[0];
  inbound = markDisabledGroupItems({
    inbound: inbound,
    selectedOutboundId: selectedOutboundId,
    itineraryLegHashMap: itineraryLegHashMap,
    groupIds: groupIds
  });
  var selectedInboundId = inbound[0].code;
  return {
    outbound: outbound,
    inbound: inbound,
    selectedOutboundId: selectedOutboundId,
    selectedInboundId: selectedInboundId
  };
}
function legacyInitializeGroupState(group, itineraryLegHashMap) {
  var outboundIds = [];
  var inboundIds = [];
  var groupIds = (0, _map2.default)(group, 'id');
  (0, _each2.default)(group, function (result) {
    var _result$legs5, _result$legs5$, _result$legs6, _result$legs6$;
    var outboundId = result === null || result === void 0 ? void 0 : (_result$legs5 = result.legs) === null || _result$legs5 === void 0 ? void 0 : (_result$legs5$ = _result$legs5[0]) === null || _result$legs5$ === void 0 ? void 0 : _result$legs5$.id;
    var inboundId = result === null || result === void 0 ? void 0 : (_result$legs6 = result.legs) === null || _result$legs6 === void 0 ? void 0 : (_result$legs6$ = _result$legs6[1]) === null || _result$legs6$ === void 0 ? void 0 : _result$legs6$.id;
    !outboundIds.includes(outboundId) && outboundIds.push(outboundId);
    !inboundIds.includes(inboundId) && inboundIds.push(inboundId);
  });
  var outbound = (0, _map2.default)(outboundIds, function (id, i) {
    return {
      code: id,
      selected: i === 0,
      disabled: false
    };
  });
  var inbound = (0, _map2.default)(inboundIds, function (id, i) {
    return {
      code: id,
      selected: i === 0,
      disabled: false
    };
  });
  var selectedOutboundId = outboundIds[0];
  inbound = markDisabledGroupItems({
    inbound: inbound,
    selectedOutboundId: selectedOutboundId,
    itineraryLegHashMap: itineraryLegHashMap,
    groupIds: groupIds
  });
  return {
    outbound: outbound,
    inbound: inbound
  };
}
function markDisabledGroupItems(_ref) {
  var inbound = _ref.inbound,
    selectedOutboundId = _ref.selectedOutboundId,
    itineraryLegHashMap = _ref.itineraryLegHashMap,
    groupIds = _ref.groupIds;
  var hasSelectedItem = true;
  var groupItems = (0, _map2.default)(inbound, function (item) {
    var _itineraryLegHashMap$;
    var inboundId = item === null || item === void 0 ? void 0 : item.code;
    var key = [selectedOutboundId, inboundId].join(_constants.LEG_IDS_SEPARATOR);
    var itineraryId = itineraryLegHashMap === null || itineraryLegHashMap === void 0 ? void 0 : (_itineraryLegHashMap$ = itineraryLegHashMap[key]) === null || _itineraryLegHashMap$ === void 0 ? void 0 : _itineraryLegHashMap$.id;
    var disabled = !(0, _includes2.default)(groupIds, itineraryId);
    var previouslySelected = disabled && item.selected;
    var selected = !disabled ? item.selected : false;
    var leg = item.leg;
    if (previouslySelected) {
      hasSelectedItem = false;
    }
    return _objectSpread(_objectSpread({}, item), {}, {
      disabled: disabled,
      selected: selected,
      previouslySelected: previouslySelected,
      leg: leg
    });
  });
  var firstAvailableItemIndex = (0, _findIndex2.default)(groupItems, {
    disabled: false
  });
  if (!hasSelectedItem && firstAvailableItemIndex !== -1) {
    groupItems[firstAvailableItemIndex].selected = true;
  }
  return groupItems;
}
function updateItineraryGroup(_ref2) {
  var inbound = _ref2.inbound,
    itineraryLegHashMap = _ref2.itineraryLegHashMap,
    itineraryGroup = _ref2.itineraryGroup,
    selectedOutboundId = _ref2.selectedOutboundId,
    selectedInboundId = _ref2.selectedInboundId;
  var disabledItems = markDisabledGroupItems({
    inbound: inbound,
    selectedOutboundId: selectedOutboundId,
    itineraryLegHashMap: itineraryLegHashMap,
    groupIds: (0, _map2.default)(itineraryGroup, 'id')
  });
  var isCurrentSelectionDisabled = disabledItems.find(function (item) {
    return item.code === selectedInboundId && item.disabled;
  });
  var nextToSelect = disabledItems.find(function (item) {
    return !item.disabled;
  });
  var inboundNextSelected = isCurrentSelectionDisabled ? nextToSelect.code : selectedInboundId;
  var outboundNextSelected = selectedOutboundId;
  return {
    inbound: disabledItems,
    inboundNextSelected: inboundNextSelected,
    outboundNextSelected: outboundNextSelected
  };
}
function updateGroupState(_ref3) {
  var groupState = _ref3.groupState,
    itineraryLegHashMap = _ref3.itineraryLegHashMap,
    payload = _ref3.payload,
    groupIds = _ref3.groupIds;
  if (!(0, _isPlainObject2.default)(payload) || !(0, _isPlainObject2.default)(groupState) || !_constants.FLIGHT_DIRECTIONS.includes(payload.direction)) {
    return groupState;
  }
  var code = payload.code,
    direction = payload.direction;
  var nextGroupState = _objectSpread({}, groupState);
  nextGroupState[direction] = (0, _map2.default)(groupState[direction], function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      selected: item.code === code
    });
  });
  if (direction === _constants.OUTBOUND) {
    nextGroupState[_constants.INBOUND] = markDisabledGroupItems({
      inbound: groupState[_constants.INBOUND],
      selectedOutboundId: code,
      itineraryLegHashMap: itineraryLegHashMap,
      groupIds: groupIds
    });
  }
  return nextGroupState;
}
function getGroupedByLegSearchResults(_ref4) {
  var groupsState = _ref4.groupsState,
    itineraryLegHashMap = _ref4.itineraryLegHashMap,
    legHashMap = _ref4.legHashMap;
  return (0, _map2.default)(groupsState, function (groupState) {
    var _find2, _find3;
    var outboundState = groupState === null || groupState === void 0 ? void 0 : groupState[_constants.OUTBOUND];
    var inboundState = groupState === null || groupState === void 0 ? void 0 : groupState[_constants.INBOUND];
    var outbound = getGroupedByLegSearchResult(outboundState, legHashMap);
    var inbound = getGroupedByLegSearchResult(inboundState, legHashMap);
    var selectedOutboundId = (_find2 = (0, _find4.default)(outboundState, 'selected')) === null || _find2 === void 0 ? void 0 : _find2.code;
    var selectedInboundId = (_find3 = (0, _find4.default)(inboundState, 'selected')) === null || _find3 === void 0 ? void 0 : _find3.code;
    var selectedItineraryId = [selectedOutboundId, selectedInboundId].join(_constants.LEG_IDS_SEPARATOR);
    var selectedItinerary = itineraryLegHashMap[selectedItineraryId];
    return {
      inbound: inbound,
      outbound: outbound,
      selectedItinerary: selectedItinerary
    };
  });
}
function getGroupedByLegSearchResult(groupItems, legHashMap) {
  return (0, _map2.default)(groupItems, function (groupItem) {
    var leg = legHashMap[groupItem.code];
    return _objectSpread(_objectSpread({}, groupItem), {}, {
      leg: leg
    });
  });
}
function getGroupedCheapestPriceByDate(results) {
  return (0, _reduce2.default)(results, function (groups, _ref5) {
    var firstLegDepartureTime = _ref5.firstLegDepartureTime,
      totalPrice = _ref5.totalPrice;
    var key = (0, _format.default)(new Date(firstLegDepartureTime), _constants.SEARCH_BOX_CONSTANTS.REQUEST_DATE_FORMAT);
    if (!groups[key] || groups[key] && groups[key] > totalPrice) {
      groups[key] = totalPrice;
    }
    return groups;
  }, {});
}
var _default = exports.default = group;